<template>
  <div class="part3">
    <div class="partbox pr" tabindex="0">
      <div class="poster bg">
        <div class="swiperPageSevent pr">
          <!-- 轮播 -->
          <div class="swiper">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in imgList"
                :key="'swiper' + index"
                class="swiper-slide"
              >
                <img
                  :src="item.src"
                  style="width: 100%; height: 100%"
                  :alt="index"
                />
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-prev"></div>
          <div class="swiper-next"></div>
          <!-- 如果需要分页器 -->
          <!-- <div class="swiper-pagination"></div> -->
        </div>
      </div>

      <div class="p_btn mt dl">
        <!-- <p class="Btn">保存结果</p> -->
        <!-- <p class="Btn">分享至facebook</p> -->
        <!-- <p class="Btn" @click="dialogOpen">开始测试</p> -->
        <img
          src="@/assets/images/page3/weapon_title.png"
          alt=""
          class="weapon_title"
        />
        <img
          src="@/assets/images/page3/begintestbtn.png"
          alt=""
          class="Btn"
          @click="dialogOpen"
          :class="{ disable: disable }"
        />
      </div>
    </div>
    <img
      src="@/assets/images/page3/checkresult.png"
      alt=""
      class="checkresult"
      @click="checkresult"
    />
  </div>
</template>

<script>
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swipe
export default {
  name: "pageThree",
  props: ["allCode"],
  data() {
    return {
      shareCode: "", //分享礼包码
      imgList: [
        {
          src: require("@/assets/images/page3/weapon1.png"),
        },
        {
          src: require("@/assets/images/page3/weapon2.png"),
        },
        {
          src: require("@/assets/images/page3/weapon3.png"),
        },
        {
          src: require("@/assets/images/page3/weapon4.png"),
        },
        {
          src: require("@/assets/images/page3/weapon5.png"),
        },
        {
          src: require("@/assets/images/page3/weapon6.png"),
        },
      ],
      disable: false,
      isopened: true,
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    // console.log(this.allCode);
    this.createdSwiper();
    this.$bus.$on("point2", () => {
      this.anchor();
    });
    this.$bus.$on("notest", () => {
      this.disable = true;
    });
    this.$nextTick(() => {
      this.$on("pagethree", () => {
        // console.log(res);
        // if (res !== 0) {
        this.disable = true;
        // }
      });
    });
  },
  methods: {
    createdSwiper() {
      new Swiper(".swiperPageSevent .swiper", {
        autoplay: {
          disableOnInteraction: true,
          delay: 40000,
        },
        //前进后退按钮
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        loop: true, //循环模式选项
      });
    },
    checkresult() {
      if (this.disable) {
        this.$emit("dialogresult");
      } else {
        this.$bus.$emit("tips", "請開始測試");
      }
    },
    //定位
    anchor() {
      let ele = document.getElementsByClassName("partbox")[0];
      ele.scrollIntoView({ behavior: "smooth", block: "center" });
      // let eletop = ele.scrollTop;
      // console.log(eletop);
      // window.scrollTo({
      //   top: eletop,
      //   behavior: "smooth",
      // });
    },
    dialogOpen() {
      this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");
      // let token = this.$util.getToken();
      // if (this.disable) {
      //   return;
      // }
      // if (!token) {
      //   // alert("請先預約");
      //   this.$bus.$emit("tips", "請先預約");
      //   return;
      // }
      // if (this.isopened) {
      //   //第一次已经打开过了，不用再次请求题目
      //   this.$emit("dialog", true);
      //   this.isopened = false;
      // } else {
      //   this.$emit("dialog");
      // }
      // this.$xmlog.gameStart();
    },
  },
};
</script>

<style lang="less" scoped>
.part3 {
  width: 100%;
  text-align: center;
  position: relative;
  .partbox {
    margin-top: 5.6rem;
    .poster {
      width: 82%;
      margin: 0rem 0.7rem;
      .swiperPageSevent {
        width: 100%;
        height: 100%;
        // padding: 1.55rem 0.6rem 0 0.6rem;
        .swiper {
          height: 9.2rem;
          width: 100%;
          // height: 100%;
          overflow: hidden;
          border-radius: 0.2rem;
        }
        .swiper-pagination {
          // background: url("@/assets/images/swiper_strip.png") no-repeat;
          // background-position: center;
          width: 90%;
          transform: translateX(-50%);
          left: 50%;
          position: relative;
        }
        .swiper-line {
          height: 1px;
          width: 90%;
          background: #0c3220;
          position: absolute;
          bottom: 0.07rem;
          left: 50%;
          transform: translateX(-50%);
        }
        .swiper-next {
          right: -0.5rem;
          top: 50%;
          transform: translateY(-50%);
          background: url("@/assets/images/page3/arrows_right.png");
          position: absolute;
          position: absolute;
          width: 0.82rem;
          height: 1rem;
          z-index: 90;
          cursor: pointer;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .swiper-prev {
          left: -0.5rem;
          top: 50%;
          transform: translateY(-50%);
          background: url("@/assets/images/page3/arrows_left.png");
          position: absolute;
          width: 0.82rem;
          height: 1rem;
          z-index: 90;
          cursor: pointer;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .p_btn {
      flex-direction: column;
      position: absolute;
      bottom: 0.5rem;
      z-index: 1;
      left: 50%;
      width: 84%;
      transform: translateX(-50%);
      .Btn {
        width: 3rem;
        cursor: pointer;
        // animation: scale 1.5s infinite;
      }
      .disable {
        cursor: no-drop;
        filter: grayscale(100%);
      }
      .weapon_title {
        width: 90%;
      }
    }
  }
  .checkresult {
    width: 80%;
    cursor: pointer;
    position: absolute;
    bottom: -0.7rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@media screen and (min-width: 710px) {
  .poster {
    margin: 1.5rem 0.6rem 0 0.7rem !important;
  }
}
</style>